/**
 * Severities para los tags de PrimeNG
 */
export const SEVERITY_TAG = {
  success: 'success' as const,
  secondary: 'secondary' as const,
  info: 'info' as const,
  warn: 'warn' as const,
  danger: 'danger' as const,
  contrast: 'contrast' as const,
} as const;

export type SeverityTag = (typeof SEVERITY_TAG)[keyof typeof SEVERITY_TAG];
